import React, { useEffect, useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

import { DEFAULT_MASKS } from '../../servicio/ServicioConstantes';
import { CALENDARIO_ES_MX } from '../../servicio/ServicioConstantes';

import servicioHttp from '../../servicio/ServicioHttp';
import servicioObjetos from '../../servicio/ServicioObjetos';

const ETIQUETAS_REQUERIDAS_08_07 = {
    tipoMovimiento: true,
    numeroAfiliacion: true,
    digitoVerfificador: true,
    curp: false,
    apPaterno: true,
    apMaterno: false,
    nombre: true,
    salario: true,
    tipoTrabajador: true,
    tipoSalario: true,
    jornada: true,
    umf: false,
    fechaMovimiento: true,
    causaBaja: true,
}

let ETIQUETAS_REQUERIDAS_02 = {
    tipoMovimiento: true,
    numeroAfiliacion: true,
    digitoVerfificador: true,
    curp: false,
    apPaterno: true,
    apMaterno: false,
    nombre: true,
    salario: false,
    tipoTrabajador: false,
    tipoSalario: false,
    jornada: false,
    umf: false,
    fechaMovimiento: true,
    causaBaja: true
};

const tiposMovimiento = [
    { label: "* Tipo de movimiento", value: null },
    { label: "Reingreso", value: "08" },
    { label: "Modificación de SBC", value: "07" },
    { label: "Baja", value: "02" },
];

const tipoTrabajador = [
    { label: "* Tipo de Trabajador", value: null },
    { label: "PERMANENTE", value: "1" },
    { label: "EVENTUAL", value: "2" },
    { label: "EVENTUAL DE LA CONSTRUCCION", value: "3" },
];

const tipoSalario = [
    { label: "* Tipo de Salario", value: null },
    { label: "SALARIO FIJO", value: "0" },
    { label: "SALARIO VARIABLE", value: "1" },
    { label: "SALARIO MIXTO", value: "2" },
];

const tipoJornada = [
    { label: "* Jornada o Semana Reducida", value: null },
    { label: "JORNADA NORMAL", value: "0" },
    { label: "JORNADA REDUCIDA", value: "6" },
];

const causaBaja = [
    { label: "* Causa Baja", value: null },
    { label: "Termino de contrato", value: "1" },
    { label: "Separación voluntaria", value: "2" },
    { label: "Abandono de empleo", value: "3" },
    { label: "Defunción", value: "4" },
    { label: "Clausura", value: "5" },
    { label: "Otras", value: "6" },
    { label: "Ausentismo", value: "7" },
    { label: "Rescisión de contrato", value: "8" },
    { label: " Jubilación", value: "9" },
    { label: " Pensión", value: "A" },
];
export const FormularioManual2023 = (props) => {

    const { movimiento, setMovimiento, setMovimientosCapturados,
        setMovimientosSeleccionados } = props;
    const [registrosPatronales, setRegistrosPatronales] = useState([]);
    const [errores, setErrores] = useState({});
    const [etiquetasRequeridas, setEtiquetasRequeridas] = useState(Object.freeze(ETIQUETAS_REQUERIDAS_08_07));
    const [mostrarFechaMovimiento, setMostrarFechaMovimiento] = useState(true);

    useEffect(() => {
        obtenerRegistrosPatronales();
    }, []);


    const obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [{ label: "* Elije un registro patronal", value: null }];
            var newArray = registrosPatronales.concat(response.data.lista);
            setRegistrosPatronales(newArray);
        }).catch(error => {

        });
    };

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setMovimiento((prevMovimiento) => {
            const newMovimiento = { ...prevMovimiento }
            if (name.includes(".")) {
                let elementos = name.split(".");
                var nombreObjeto = elementos[0];
                var laPropiedad = elementos[1];
                newMovimiento[nombreObjeto][laPropiedad] = elValor;
            } else {
                newMovimiento[name] = elValor;
            }
            return newMovimiento;
        });
        validarCambioTipoMovimiento(name, value);
    };

    const validarCambioTipoMovimiento = (nombreElemento, valor) => {
        if (nombreElemento === "tipoMovimiento") {
            if (valor === "02") {
                setEtiquetasRequeridas(ETIQUETAS_REQUERIDAS_02);
                setMovimiento(valoresUsuarioPrevios => ({
                    ...valoresUsuarioPrevios,
                    tipoTrabajador: null,
                    tipoSalario: null,
                    jornadaReducida: null,
                    salarioDiarioIntegrado: null,
                }));
            } else {
                setMovimiento(valoresUsuarioPrevios => ({
                    ...valoresUsuarioPrevios,
                    causaBaja: null
                }));
                setEtiquetasRequeridas(ETIQUETAS_REQUERIDAS_08_07);
            }
        }
    }

    const generateID = ()=> {
        return Math.random().toString(36).slice(2)
     }

    const agregarDatos = () => {
        const errores = validarObjetoFormulario();
        setErrores(errores);
        if (servicioObjetos.esObjetoVacio(errores)) {
            setMovimientosCapturados(movimientos => {
                let { elId } = movimiento;
                if (servicioObjetos.esObjetoVacio(elId)) {
                    elId=generateID();
                    movimiento.elId=elId;
                    movimientos.push(movimiento);
                } else {
                    let elMovimiento = servicioObjetos.obtenerObjetoDeArregloPorPropiedad(movimientos, 'elId', elId);
                    servicioObjetos.eliminarObjetoMapa(movimientos, elMovimiento);
                    movimientos.push(movimiento);
                }
                return movimientos;
            });
            setMovimientosSeleccionados([]);

            setMovimiento({
                tcTrabajador: {},
                registroPatronal: "* Elije un registro patronal"
            });
            manejadorCalendar();
        }
    }

    const limpiarDatos = () => {
        setMovimiento({
            tcTrabajador: {},
            registroPatronal: "* Elije un registro patronal"
        });
        setEtiquetasRequeridas(ETIQUETAS_REQUERIDAS_08_07);
        manejadorCalendar();
        setErrores({});
    }

    const manejadorCalendar= () => {
        setMostrarFechaMovimiento(false);
        setTimeout(() => {
            setMostrarFechaMovimiento(true);
        }, 50);
    }

    const validarObjetoFormulario = () => {
        let errores = {};
        if (servicioObjetos.esObjetoVacio(movimiento.registroPatronal) || movimiento.registroPatronal==="* Elije un registro patronal")
            errores.registroPatronal = "Seleccione un registro patronal";
        if (servicioObjetos.esObjetoVacio(movimiento.tipoMovimiento))
            errores.tipoMovimiento = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(movimiento.tcTrabajador.numeroSeguridadSocial))
            errores.numeroSeguridadSocial = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(movimiento.digitoVerificador))
            errores.digitoVerificador = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(movimiento.tcTrabajador.primerApellido))
            errores.primerApellido = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(movimiento.tcTrabajador.nombre))
            errores.nombre = "Ingrese información requerida";
        if (servicioObjetos.esObjetoVacio(movimiento.fechaMovimiento))
            errores.fechaMovimiento = "Ingrese información requerida";
        if (movimiento.tipoMovimiento !== "02") {
            if (servicioObjetos.esObjetoVacio(movimiento.salarioDiarioIntegrado))
                errores.salarioDiarioIntegrado = "Ingrese información requerida";

            if (servicioObjetos.esObjetoVacio(movimiento.tipoSalario))
                errores.tipoSalario = "Ingrese información requerida";

            if (servicioObjetos.esObjetoVacio(movimiento.tipoTrabajador))
                errores.tipoTrabajador = "Ingrese información requerida";

            if (servicioObjetos.esObjetoVacio(movimiento.jornadaReducida))
                errores.jornadaReducida = "Ingrese información requerida";
        } else {
            if (servicioObjetos.esObjetoVacio(movimiento.causaBaja))
                errores.causaBaja = "Ingrese información requerida";

            if (!servicioObjetos.esObjetoVacio(movimiento.salarioDiarioIntegrado))
                errores.salarioDiarioIntegrado = "Información no requerida";

            if (!servicioObjetos.esObjetoVacio(movimiento.tipoSalario))
                errores.tipoSalario = "Información no requerida";

            if (!servicioObjetos.esObjetoVacio(movimiento.tipoTrabajador))
                errores.tipoTrabajador = "Información no requerida";

            if (!servicioObjetos.esObjetoVacio(movimiento.jornadaReducida))
                errores.jornadaReducida = "Información no requerida";
        }

        if (!servicioObjetos.esObjetoVacio(movimiento.curp)) {
            var expreg = new RegExp("^[A-Z][AEIOUX][A-Z]{2}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[MH]([ABCMTZ]S|[BCJMOT]C|[CNPST]L|[GNQ]T|[GQS]R|C[MH]|[MY]N|[DH]G|NE|VZ|DF|SP)[BCDFGHJ-NP-TV-Z]{3}[0-9A-Z][0-9]$");
            if (!expreg.test(movimiento.curp)) {
                errores.curp = "El curp " + movimiento.curp + " no cumple con un formato valido";
            }
        }

        if (!servicioObjetos.esObjetoVacio(movimiento.salarioDiarioIntegrado)) {
            let salidario = Number(movimiento.salarioDiarioIntegrado);
            if (salidario < 148.11)
                errores.salarioDiarioIntegrado = "El Salario Base de Cotización no puede ser menor a 148.11";
        }
        return errores;
    }

    let calendarioFechaMovimiento =
        <div className="p-col-12 p-md-6">
            <span className="md-inputfield">
                <Calendar dateFormat="ddmmyy" name="fechaMovimiento"
                    value={movimiento.fechaMovimiento || ""} className={errores.fechaMovimiento ? "p-error" : ""}
                    onChange={(e) => handleChange(e, false)} locale={CALENDARIO_ES_MX} />
                <label>{etiquetasRequeridas.fechaMovimiento ? "*" : ""} Fecha de Movimiento</label>
                {errores.fechaMovimiento ? <div><Message severity="error" text={errores.fechaMovimiento} /></div> : null}
            </span>
        </div>;

    return (
        <div className="card">
            <h1>CARGA MANUAL</h1>
            <p>En esta sección usted puede capturar de forma manual a algún trabajador.</p>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-2">
                    <label>* Registro Patronal</label>
                </div>
                <div className="p-col-12 p-md-4">
                    <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                     appendTo={document.body} id="registroPatronal" name="registroPatronal" optionLabel="label" optionValue="label"
                        options={registrosPatronales} value={movimiento.registroPatronal} onChange={(e) => handleChange(e, false)}
                        autoWidth={false} style={{ width: "100%" }} className={errores.registroPatronal ? "p-error" : ""} />
                    {errores.registroPatronal ? <div><Message severity="error" text={errores.registroPatronal} /></div> : null}
                </div>
                <div className="p-grid form-group">
                    <div className="p-col-12 p-md-6">
                        <Dropdown appendTo={document.body} id="tipoMovimiento"
                            name="tipoMovimiento" options={tiposMovimiento}
                            value={movimiento.tipoMovimiento} onChange={(e) => handleChange(e, false)}
                            autoWidth={false} style={{ width: "90%" }} />
                        {errores.tipoMovimiento ? <div><Message severity="error" text={errores.tipoMovimiento} /></div> : null}
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText type="text" keyfilter="pint" maxLength="10"
                                id="tcTrabajador.numeroSeguridadSocial"
                                name="tcTrabajador.numeroSeguridadSocial"
                                value={movimiento.tcTrabajador.numeroSeguridadSocial || ""}
                                className={errores.numeroSeguridadSocial ? "p-error" : ""}
                                onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                            <label>{etiquetasRequeridas.numeroAfiliacion ? "*" : ""} Número de afiliación</label>
                            {errores.numeroSeguridadSocial ? <div><Message severity="error" text={errores.numeroSeguridadSocial} /> </div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText keyfilter="pint" maxLength="1" id="digitoVerificador"
                                name="digitoVerificador" value={movimiento.digitoVerificador || ""}
                                className={errores.digitoVerificador ? "p-error" : ""}
                                onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                            <label>{etiquetasRequeridas.digitoVerfificador ? "*" : ""} Dígito verificador</label>
                            {errores.digitoVerificador ? <div><Message severity="error" text={errores.digitoVerificador} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText keyfilter={DEFAULT_MASKS.alphanum} id="curp" name="curp"
                                maxLength="18" value={movimiento.curp || ""} className={errores.curp ? "p-error" : ""}
                                onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                            <label> CURP</label>
                            {errores.curp ? <div><Message severity="error" text={errores.curp} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText keyfilter="pint" id="claveTrabajador"
                                name="claveTrabajador" maxLength="10" value={movimiento.claveTrabajador || ""}
                                className={errores.curp ? "p-error" : ""} onChange={(e) => handleChange(e, true)}
                                style={{ width: "90%" }} />
                            <label>Clave Trabajador</label>
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText maxLength="27" keyfilter={DEFAULT_MASKS.alphaspace}
                                id="tcTrabajador.primerApellido" name="tcTrabajador.primerApellido"
                                value={movimiento.tcTrabajador.primerApellido || ""}
                                className={errores.primerApellido ? "p-error" : ""}
                                onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                            <label>{etiquetasRequeridas.apPaterno ? "*" : ""} Apellido Paterno</label>
                            {errores.primerApellido ? <div><Message severity="error" text={errores.primerApellido} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText maxLength="27" keyfilter={DEFAULT_MASKS.alphaspace}
                                id="tcTrabajador.segundoApellido" name="tcTrabajador.segundoApellido"
                                value={movimiento.tcTrabajador.segundoApellido || ""}
                                className={errores.segundoApellido ? "p-error" : ""} onChange={(e) => handleChange(e, true)}
                                style={{ width: "90%" }} />
                            <label>Apellido Materno</label>
                            {errores.segundoApellido ? <div><Message severity="error" text={errores.segundoApellido} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText maxLength="27" keyfilter={DEFAULT_MASKS.nombreIdse}
                                id="tcTrabajador.nombre" name="tcTrabajador.nombre"
                                value={movimiento.tcTrabajador.nombre || ""} className={errores.nombre ? "p-error" : ""}
                                onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                            <label>{etiquetasRequeridas.nombre ? "*" : ""} Nombre (s) del Asegurado</label>
                            {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText disabled={!etiquetasRequeridas.salario} maxLength="7" keyfilter={DEFAULT_MASKS.money}
                                id="salarioDiarioIntegrado" name="salarioDiarioIntegrado"
                                value={movimiento.salarioDiarioIntegrado || ""}
                                className={errores.salarioDiarioIntegrado ? "p-error" : ""}
                                onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                            <label>{etiquetasRequeridas.salario ? "*" : ""} Salario Base de Cotización</label>
                            {errores.salarioDiarioIntegrado ? <div><Message severity="error" text={errores.salarioDiarioIntegrado} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <Dropdown disabled={!etiquetasRequeridas.tipoTrabajador} appendTo={document.body}
                                id="tipoTrabajador" name="tipoTrabajador" options={tipoTrabajador}
                                value={movimiento.tipoTrabajador} onChange={(e) => handleChange(e, false)}
                                autoWidth={false} style={{ width: "90%" }} />
                            {errores.tipoTrabajador ? <div><Message severity="error" text={errores.tipoTrabajador} /></div> : null}
                        </span>
                    </div>

                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <Dropdown disabled={!etiquetasRequeridas.tipoSalario} appendTo={document.body}
                                id="tipoSalario" name="tipoSalario" options={tipoSalario}
                                value={movimiento.tipoSalario} onChange={(e) => handleChange(e, false)}
                                autoWidth={false} style={{ width: "90%" }} />
                            {errores.tipoSalario ? <div><Message severity="error" text={errores.tipoSalario} /></div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <Dropdown disabled={!etiquetasRequeridas.jornada} appendTo={document.body}
                                id="jornadaReducida" name="jornadaReducida"
                                options={tipoJornada} value={movimiento.jornadaReducida}
                                onChange={(e) => handleChange(e, false)} autoWidth={false} style={{ width: "90%" }} />
                            {errores.jornadaReducida ? <div><Message severity="error" text={errores.jornadaReducida} /></div> : null}
                        </span>
                    </div>
                    <div className="p-col-12 p-md-6">
                        <span className="md-inputfield">
                            <InputText keyfilter={DEFAULT_MASKS.pint} maxLength="3" id="umf"
                                name="umf" value={movimiento.umf || ""} className={errores.umf ? "p-error" : ""}
                                onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                            <label>UMF</label>
                            {errores.umf ? <div><Message severity="error" text={errores.umf} /></div> : null}
                        </span>
                    </div>

                    {mostrarFechaMovimiento ? calendarioFechaMovimiento : null}

                    {movimiento.tipoMovimiento === "02" ?
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <Dropdown appendTo={document.body} id="causaBaja" name="causaBaja"
                                    options={causaBaja} value={movimiento.causaBaja}
                                    onChange={(e) => handleChange(e, false)} autoWidth={false} style={{ width: "90%" }} />
                                {errores.causaBaja ? <div><Message severity="error" text={errores.causaBaja} /></div> : null}
                            </span>
                        </div>
                        : null}
                </div>
                <div className="p-col-12 p-md-6">
                    <Button label="Agregar" icon="pi-md-plus" onClick={agregarDatos} />
                </div>
                <div className="p-col-12 p-md-6">
                    <Button label="Limpiar" icon="pi-md-refresh" onClick={limpiarDatos} />
                </div>
            </div>
        </div>

    );
}